import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import ProductGrid from '../../components/products/ProductGrid';
import ProductStats from '../../components/products/ProductStats';
import Pagination from '../../components/common/Pagination';
import Button from '../../components/common/Button';
import { useProducts } from '../../hooks/useProducts';
import { productService } from '../../services/product.service';
import { useToast } from '../../components/common/Toast';
import { theme } from '../../config/theme';
import { PlusIcon, PackageIcon } from '../../components/icons/Icons';

const SellerProducts = () => {
  const navigate = useNavigate();
  const toast    = useToast();

  // stats are server-computed — accurate across all pages, not just the current one
  const { products, pagination, stats, loading, refresh, goToPage } = useProducts({}, {}, 'getMyProducts');

  const handleProductClick = (product) => {
    navigate(`/seller/products/${product.id}`);
  };

  const handleEdit = (product) => {
    navigate(`/seller/products/${product.id}/edit`);
  };

  const handleDelete = async (product) => {
    if (!window.confirm(`Delete "${product.name}"?`)) return;
    try {
      await productService.delete(product.id);
      toast.success('Product deleted');
      refresh();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Delete failed');
    }
  };

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: theme.spacing.xl
        }}>
          <div>
            <h1 style={{
              fontSize: theme.typography.fontSize['3xl'],
              fontWeight: theme.typography.fontWeight.bold,
              marginBottom: theme.spacing.xs
            }}>
              My Products
            </h1>
            <p style={{ color: theme.colors.text.secondary }}>
              Manage your product catalog
            </p>
          </div>
          <Button onClick={() => navigate('/seller/products/create')}>
            <PlusIcon size={20} />
            Add Product
          </Button>
        </div>

        {/* Stats — server-computed, always accurate */}
        <div style={{ marginBottom: theme.spacing.xl }}>
          <ProductStats stats={stats} />
        </div>

        {/* Product grid */}
        <ProductGrid
          products={products}
          loading={loading}
          showActions
          onClick={handleProductClick}
          onEdit={handleEdit}
          onDelete={handleDelete}
          emptyMessage="No products found"
          emptyAction={
            <Button onClick={() => navigate('/seller/products/create')}>
              <PackageIcon size={20} />
              Create First Product
            </Button>
          }
        />

        {/* Pagination */}
        <Pagination
          currentPage={pagination.page}
          totalPages={pagination.totalPages}
          hasNextPage={pagination.hasNextPage}
          hasPreviousPage={pagination.hasPreviousPage}
          totalItems={pagination.total}
          itemsPerPage={pagination.limit}
          onPageChange={goToPage}
        />
      </div>
    </MainLayout>
  );
};

export default SellerProducts;